import { oc } from '@orpc/contract';
import { listServiceEventsOutputSchema, removeServiceEventInputSchema } from '../schemas/history.schemas.js';
export const removeServiceEventContract = oc
    .route({
    method: 'DELETE',
    path: '/history/{id}',
    tags: ['History'],
    summary: 'Remove a historical service event',
})
    .input(removeServiceEventInputSchema)
    .output(listServiceEventsOutputSchema);
//# sourceMappingURL=remove-service-event.contract.js.map